import type { PlayerId, TeamId } from '../content/types';
import type { MatchState } from './state';

export function playerIds(state: Pick<MatchState, 'players'>): PlayerId[] {
  return state.players.map((player) => player.id);
}

export function teamOf(state: Pick<MatchState, 'players'>, player: PlayerId): TeamId {
  return state.players[player].team;
}

export function areAllies(state: Pick<MatchState, 'players'>, a: PlayerId, b: PlayerId): boolean {
  return teamOf(state, a) === teamOf(state, b);
}

export function areHostile(state: Pick<MatchState, 'players'>, a: PlayerId, b: PlayerId): boolean {
  return !areAllies(state, a, b);
}

export function enemyPlayerIds(state: Pick<MatchState, 'players'>, player: PlayerId): PlayerId[] {
  return playerIds(state).filter((candidate) => areHostile(state, player, candidate));
}

export function allyPlayerIds(state: Pick<MatchState, 'players'>, player: PlayerId): PlayerId[] {
  return playerIds(state).filter((candidate) => candidate !== player && areAllies(state, player, candidate));
}

export function opposingTeam(team: TeamId): TeamId {
  return team === 0 ? 1 : 0;
}
